import { render, staticRenderFns } from "./b-ticket-share-button.vue?vue&type=template&id=dd3cbfaa&scoped=true"
import script from "./b-ticket-share-button.vue?vue&type=script&lang=ts"
export * from "./b-ticket-share-button.vue?vue&type=script&lang=ts"
import style0 from "./b-ticket-share-button.vue?vue&type=style&index=0&id=dd3cbfaa&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3cbfaa",
  null
  
)

export default component.exports